if (!customElements.get('cerberus-cart-upsell')) {
  class CerberusCartUpsell extends HTMLElement {
    static pending = false;
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        event.preventDefault();
        if (CerberusCartUpsell.pending) return;
        CerberusCartUpsell.pending = true;
        const buttons = document.querySelectorAll('cerberus-cart-upsell button');
        buttons.forEach(button => { button.disabled = true; });
        this.setAttribute('aria-busy', 'true');
        const error = this.querySelector('.cerb-growth-error');
        error.hidden = true;
        try {
          const drawer = this.dataset.context === 'drawer' ? document.querySelector('cart-drawer') : null;
          const data = new FormData(form);
          data.delete('return_to');
          if (drawer) {
            data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
            data.append('sections_url', window.location.pathname);
          }
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const result = await response.json();
          if (!response.ok || result.status) {
            error.textContent = typeof result.description === 'string' ? result.description : error.textContent;
            error.hidden = false;
            return;
          }
          if (drawer && result.sections && result.sections['cart-drawer']) {
            drawer.renderContents(result);
          } else {
            window.location.assign(root + 'cart');
          }
        } catch (_) {
          error.hidden = false;
        } finally {
          CerberusCartUpsell.pending = false;
          buttons.forEach(button => { button.disabled = false; });
          this.removeAttribute('aria-busy');
        }
      });
    }
  }
  customElements.define('cerberus-cart-upsell', CerberusCartUpsell);
}
